import { useEffect } from "react";

/**
 * Sets the page <title> and meta description per route (Googlebot executes JS, so
 * DOM updates are indexed). Non-JS crawlers still get the static head in index.html.
 * Restores the default homepage title when the page unmounts.
 */
const DEFAULT_TITLE = "Savy Kerno — AI Voice + Marketing Platform";
const DEFAULT_DESC = "Savy Kerno — one intelligent platform for AI voice agents, customer relationships and digital marketing.";

export default function useSeo(title, description) {
  useEffect(() => {
    document.title = title || DEFAULT_TITLE;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", description || DEFAULT_DESC);
    return () => {
      document.title = DEFAULT_TITLE;
      meta.setAttribute("content", DEFAULT_DESC);
    };
  }, [title, description]);
}
